import { salaryCreditIds } from "@paisa/reconciliation"
import type { TransactionRow } from "@/hooks/use-transactions"

/**
 * Uncategorised salary credits and the household's Salary category, for the
 * web Auto-categorize dialog. Same on-device rule as MCP rescan (UAT J4-01).
 * Null when there's nothing to do or no Salary category.
 */
export function salaryPlan<C extends { id: string; slug: string }>(
  rows: TransactionRow[],
  categories: C[],
): { ids: string[]; category: C } | null {
  const category = categories.find((c) => c.slug === "salary")
  if (!category) return null
  const ids = salaryCreditIds(
    rows.map((t) => ({
      id: t.id,
      type: t.type,
      description: t.description,
      categoryId: t.category?.id ?? null,
      isTransfer: t.isTransfer,
      isIgnored: t.isIgnored,
    })),
  )
  return ids.length > 0 ? { ids, category } : null
}
